import React from 'react';
import { useAlgoliaSearch } from '../hooks/useAlgoliaSearch';
import { DataContext, DataStateContext } from './Data.context';
import { useAlgoliaCapsuleSearch } from '../capsule-collections/hooks/useAlgoliaCapsuleSearch';
import { useDynamicConfigs } from '../hooks/useDynamicConfigs';
export const AlgoliaDataProvider = ({ children }) => {
    const { collection } = useDynamicConfigs();
    const [data, dataState] = collection?.capsuleItems !== undefined && collection.capsuleItems.length > 0
        ? useAlgoliaCapsuleSearch()
        : useAlgoliaSearch();
    return (React.createElement(DataContext.Provider, { value: data },
        React.createElement(DataStateContext.Provider, { value: dataState }, children)));
};
